import { useTheme } from "@/src/styles/theme-provider";
import { Lock1 } from "iconsax-react-nativejs";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type PermissionDeniedProps = Readonly<{
  /** i18n key for the headline (defaults to a generic "Access restricted"). */
  titleKey?: string;
  /** i18n key for the explanation line. */
  messageKey?: string;
}>;

/**
 * Shown in place of a list/detail when the current user lacks the *view*
 * permission for that resource. Keeps the screen meaningful instead of blank.
 */
const PermissionDenied = ({
  titleKey = "LABEL_NO_VIEW_PERMISSION_TITLE",
  messageKey = "LABEL_NO_VIEW_PERMISSION_DESC",
}: PermissionDeniedProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  return (
    <View className="flex-1 items-center justify-center px-8 py-16 gap-3">
      <View className="bg-ash rounded-full p-5">
        <Lock1 size={40} color={themeVars["--color-slate-default"] as string} />
      </View>
      <Text className="text-onyx text-lg font-semibold text-center">
        {t(titleKey)}
      </Text>
      <Text className="text-slate text-sm text-center max-w-[320px]">
        {t(messageKey)}
      </Text>
    </View>
  );
};

export default PermissionDenied;
